import React, { Component } from "react";

import ToastContainer from 'react-bootstrap/ToastContainer';

import { Toast } from "react-bootstrap";

import * as constants from "../../config/constants/AppConstants";

const AUTO_HIDE_DELAY = process.env.REACT_APP_AUTO_HIDE_DELAY;

class CommonToast extends Component {
    constructor(props) {
        super(props);
        this.state = { fadingOut: false };
    }

    componentDidUpdate(prevProps) {
        const { toast, onCloseToast } = this.props;
      
        if (!prevProps.toast.show && toast.show) {
            const fadeDelay = 800;
      
            setTimeout(() => {
                this.setState({ fadingOut: true }, () => {
                    setTimeout(() => { 
                        onCloseToast?.(); 
                    }, fadeDelay);
                });
            }, AUTO_HIDE_DELAY);
        }
    }
      
    render = () => {

        let { toast } = this.props;

        let { mode, show } = toast;

        let ToastProps = constants.ToastProps[mode] || {};

        let {
            variant = "primary",
            icon = "",
            title = "",
            dismiss = false
        } = ToastProps;

        const { fadingOut } = this.state;

        if (!show) return null; 

        return (
            <ToastContainer
                className="p-3"
                position="top-end"
                style={{ minHeight: '240px' }}
            >
                <Toast
                    bg="light"
                    onClose={dismiss ? () => { this.props.onCloseToast() } : undefined}
                    show={show}
                    delay={AUTO_HIDE_DELAY}
                    autohide
                    className={`d-inline-block m-1 ${fadingOut ? "fade-out" : ""}`}
                >
                    <Toast.Header className={`bg-${variant}`}>
                        {icon && <i className={icon} style={{ marginRight: "8px", color: "#FFF" }} />}
                        <strong className="me-auto" style={{ fontSize: "0.75rem", fontWeight: "500", color: '#FFF' }}>ดำเนินการ</strong>
                    </Toast.Header>

                    <Toast.Body>
                        <span className="title-xs" style={{ color: "#000" }}>{title}</span>
                    </Toast.Body>
                </Toast>
            </ToastContainer>
        );
    };
}

export default CommonToast;